import { render } from "./MainNongNghiepThongMinh.vue?vue&type=template&id=0f0e7bf8"
import script from "./MainNongNghiepThongMinh.vue?vue&type=script&lang=js"
export * from "./MainNongNghiepThongMinh.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__